import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import map from 'lodash/map';
import PersonaIcon from '../atoms/PersonaIcon.Container';
import { getMapPosition } from './MapPosition';
import type { Persona } from '../../data/Personas';
import type { PersonaReactions } from '../../data/Reactions';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export interface StateProps {
	personas: Persona[];
	reactions: PersonaReactions;
}

export interface DispatchProps {}

export interface OwnProps {
	onPersona?: (persona: Persona) => void;
	/**
	 * If not set, all personas are enabled
	 */
	enabledPersonaIndex?: number;
}

type Props = StateProps & DispatchProps & OwnProps;

const PersonasMapLayer: FunctionComponent<Props> = (props: Props) => {
	const { personas, reactions, enabledPersonaIndex, onPersona } = props;

	const personaComponents = useMemo(
		() =>
			map(personas, (persona, index) => {
				const hasDisabledPersonas = enabledPersonaIndex !== undefined;
				const highlightPersonas = hasDisabledPersonas;
				const isDisabled =
					enabledPersonaIndex !== undefined && index !== enabledPersonaIndex;
				const position = getMapPosition(index);
				return (
					<CSSTransition
						key={`persona_${index}_${persona.name}`}
						classNames="persona"
						timeout={{ appear: 3_000, enter: 8_000, exit: 0 }}
					>
						<PersonaIcon
							persona={persona}
							negative={reactions.getFor(persona) === 'negative'}
							x={position.x}
							y={position.y}
							onClick={isDisabled ? undefined : onPersona}
							highlighted={highlightPersonas && !isDisabled}
							highlightDelay="short"
						/>
					</CSSTransition>
				);
			}),
		[personas, reactions, enabledPersonaIndex, onPersona]
	);

	return <TransitionGroup appear>{personaComponents}</TransitionGroup>;
};

export default PersonasMapLayer;
